exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".help-about ol{counter-reset:list}.help-about ol>li{list-style:none;position:relative}.help-about ol>li:before{content:counter(list, decimal) \") \";counter-increment:list;position:absolute;left:-1.3em}.help-about ol ol>li:before{content:counter(list, lower-alpha) \") \"}", ""]);

